import script from "./EditAlertView.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditAlertView.vue?vue&type=script&setup=true&lang=ts"

import "./EditAlertView.vue?vue&type=style&index=0&id=5b96e0ad&lang=scss"

const __exports__ = script;

export default __exports__